module.exports = __webpack_public_path__ + "static/media/hero1c.f618e220.jpg";